import { createBrowserRouter } from 'react-router-dom';

import { AdminResetSwPage } from '../routes/AdminResetSwPage';
import { CelebrationPage } from '../routes/CelebrationPage';
import { HomePage } from '../routes/HomePage';
import { ProfileEditorPage } from '../routes/ProfileEditorPage';
import { RoutineEditorPage } from '../routes/RoutineEditorPage';
import { RoutineLibraryPage } from '../routes/RoutineLibraryPage';
import { RoutineSelectorPage } from '../routes/RoutineSelectorPage';
import { SettingsHubPage } from '../routes/SettingsHubPage';
import { ShareImportPage } from '../routes/ShareImportPage';
import { SyncPage } from '../routes/SyncPage';
import { TaskPage } from '../routes/TaskPage';
import { ThemeEditorPage } from '../routes/ThemeEditorPage';
import { KidLayout } from './KidLayout';
import { SettingsLayout } from './SettingsLayout';

// Routes per plan/03 §Screen inventory. Sync screen and theme picker land
// with M6 and M3 respectively.
//
// Kid-facing routes share KidLayout (persistent quick-switcher); settings
// routes share SettingsLayout (PIN gate). Home stands alone because it IS
// the picker.
export const router = createBrowserRouter([
  { path: '/', element: <HomePage /> },
  {
    element: <KidLayout />,
    children: [
      { path: '/p/:profileId', element: <RoutineSelectorPage /> },
      { path: '/p/:profileId/list/:listId', element: <TaskPage /> },
      { path: '/p/:profileId/celebrate', element: <CelebrationPage /> },
    ],
  },
  {
    path: '/settings',
    element: <SettingsLayout />,
    children: [
      { index: true, element: <SettingsHubPage /> },
      { path: 'sync', element: <SyncPage /> },
      { path: 'profiles/:id', element: <ProfileEditorPage /> },
      { path: 'profiles/:id/list/:listId', element: <RoutineEditorPage /> },
      { path: 'routines', element: <RoutineLibraryPage /> },
      { path: 'routines/:listId', element: <RoutineEditorPage /> },
      { path: 'themes/new', element: <ThemeEditorPage /> },
      { path: 'themes/:themeId', element: <ThemeEditorPage /> },
    ],
  },
  // Share-import landing page per plan/02 §B. Not nested under KidLayout —
  // the preview is its own context (no quick-switcher, no profile color).
  // PIN gate is intentionally absent: a kid receiving the link should be
  // able to import without parental friction.
  { path: '/share', element: <ShareImportPage /> },
  // SW recovery deep link per plan/05; no PIN gate by design.
  { path: '/admin/reset-sw', element: <AdminResetSwPage /> },
]);
